module.exports = __webpack_public_path__ + "images/collections/collections.0e197fd2ec35638b8d79.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/collections/collections.svg
// module id = Nxa/
// module chunks = 2